module.exports = __webpack_public_path__ + "media/images/top/topics-banner-e0410855fe45e02bfbe642c8c4f21a74.webp";